import { render, staticRenderFns } from "./IbSpinner.vue?vue&type=template&id=ff4f88b2&scoped=true"
import script from "./IbSpinner.vue?vue&type=script&lang=js"
export * from "./IbSpinner.vue?vue&type=script&lang=js"
import style0 from "./IbSpinner.vue?vue&type=style&index=0&id=ff4f88b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4f88b2",
  null
  
)

export default component.exports